module.exports = __webpack_public_path__ + "static/media/contact-btn.65e9d97f.svg";